import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-6494804b");

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createBlock("div", {
    class: ['sidebar-logo-container', $props.collapse ? 'collapse' : '']
  }, [_createVNode(_Transition, {
    name: "sidebarLogoFade"
  }, {
    default: _withId(function () {
      return [_createVNode(_component_router_link, {
        key: $props.collapse ? 'collapse' : 'expand',
        class: "sidebar-logo-link",
        to: "/"
      }, {
        default: _withId(function () {
          return [_createVNode("h1", {
            class: ['sidebar-title', $props.collapse ? 'empty' : '']
          }, _toDisplayString($props.collapse ? '' : $setup.title), 3
          /* TEXT, CLASS */
          )];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  })], 2
  /* CLASS */
  );
});